import React from 'react';
import styled from 'styled-components';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import { Lightbulb } from 'styled-icons/material-outlined';

import { LoginLogoImage } from './images.component';


const LoginPageWrapper = styled.div`
    margin-top: 80px;
    @media(max-width: 1000px){
        margin-top: 20px;
    }
`

export const LoginPageTemplate = (props) =>
    <LoginPageWrapper className='w-100 d-flex flex-column justify-content-center align-items-center'>
        <MDBRow center className='w-100'>
            <MDBCol size='12' md='10' lg='7' xl='5' xxl='4' className='text-center gx-0'>
                <a href='/'>
                    <LoginLogoImage />
                </a>
                {props.children}
            </MDBCol>
        </MDBRow>
    </LoginPageWrapper>

export const PasswordPolicyNote = () =>
    <div className='note note-info text-start mt-5'>
        <p>
            <Lightbulb height='1.5rem' />
            Nie używaj tego samego hasła w różnych systemach
        </p>
        <p>
            <Lightbulb height='1.5rem' />
            Warto korzystać z menadżera haseł
        </p>
        <Lightbulb height='1.5rem' /> Dla Twojego bezpieczeństwa, hasło:
        <ul>
            <li>musi mieć co najmniej 12 znaków</li>
            <li>nie może składać się wyłącznie z cyfr</li>
            <li>nie może być podobne do Twojego loginu</li>
            <li>nie może być zbyt powszechne</li>
        </ul>
    </div>
